import React from "react";

function Badges(props) {
    const classes = handleBadgeClass(props);

    return (
        <span className={classes}>{props.children}</span>
    )
}

export default Badges;

function handleBadgeClass({color, outlined, circle, className}) {
    let classes = 'badge';
    if (typeof color !== "undefined" && color !== '') {
        if (typeof outlined !== "undefined" && outlined) {
            classes += ' badge-outlined-' + color;
        } else if (typeof circle !== "undefined" && circle) {
            classes += ' badge-circle-' + color;
        } else {
            classes += ' badge-' + color;
        }
    }

    if (typeof className !== "undefined") {
        classes += ' ' + className;
    }

    return classes;
}